<div class="max-[800px] min-[345px] flex">
  <div >
    <table class="s-table w-[340px]">
      <tr>
        <td class="s-label">日期</td>
        <td class="s-number-white">{{FormattedDate()}}</td>
        <td class="s-label">時間</td>
        <td [class]="checkStyle(0)">{{data.time}}</td>
      </tr>
      <tr>
        <td class="s-label">成交</td>
        <td [class]="checkStyle(data.close)">{{data.close}}</td>
        <td class="s-label">漲跌</td>
        <td [class]="checkStyle(data.updown)">{{data.updown}}</td>
      </tr>
      <tr>
        <td class="s-label">漲跌幅%</td>
        <td [class]="checkStyle(data.pricePercent)">{{formatPercent(data.pricePercent,1)}}</td>
        <td class="s-label">總量</td>
        <td [class]="checkStyle(data.qty)">{{data.qty}}</td>
      </tr>
      <tr>
        <td class="s-label">最高</td>
        <td [class]="checkStyle(data.high)">{{data.high}}</td>
        <td class="s-label">昨量</td>
        <td [class]="checkStyle(data.yQty)">{{data.yQty}}</td>
      </tr>
      <tr>
        <td class="s-label">最低</td>
        <td [class]="checkStyle(data.low)">{{data.low}}</td>
        <td class="s-label">昨收</td>
        <td [class]="checkStyle(data.yClose)">{{data.yClose}}</td>
      </tr>
      <tr>
        <td class="s-label">最新價</td>
        <td [class]="checkStyle(data.newPrice)">{{data.newPrice}}</td>
        <td class="s-label">開盤</td>
        <td [class]="checkStyle(data.open)">{{data.open}}</td>
      </tr>
      <tr>
        <td class="s-label">振幅%</td>
        <td [class]="checkStyle(data.updownRate)">{{formatPercent(data.updownRate,1)}}</td>
        <td class="s-label">成交值W</td>
        <td [class]="checkStyle(1)">{{amount()}}</td>
      </tr>
      <tr>
        <td class="s-label">殖利率</td>
        <td [class]="checkStyle(data.yield)">{{data.yield}}%</td>
        <td class="s-label">本益比</td>
        <td [class]="checkStyle(data.PEratio)">{{data.PEratio}}</td>
      </tr>
      <tr>
        <td class="s-label">MACD</td>
        <td [class]="checkStyle(data.macd)">{{data.macd}}</td>
        <td class="s-label">DIF</td>
        <td [class]="checkStyle(data.dif)">{{data.dif}}</td>
      </tr>
      <tr>
        <td class="s-label">OSC</td>
        <td [class]="checkStyle(data.osc)">{{data.osc}}</td>
        <td class="s-label">量增減%</td>
        <td [class]="checkStyle(data.qtyPercent)">{{formatPercent(data.qtyPercent,1)}}</td>
      </tr>
    </table>
    <table class="s-table w-[340px]">
      <tr>
        <td class="s-label">名稱</td>
        <td class="s-label font-medium">{{data.stockName}}</td>
        <td class="s-label">代號</td>
        <td class="s-label">{{data.stockno}}</td>
      </tr>
      <tr>
        <td class="s-label">sma5</td>
        <td class="flex">
          <div [class]="checkStyle(data.sma5)">{{data.sma5}}</div>
          <div [class]="checkStyle(data.sma5Dir)">{{checkDir(data.sma5Dir)}}</div>
        </td>
        <td class="s-label">上軌</td>
        <td [class]="checkStyle(data.UBdir)">{{data.UBT }}</td>
      </tr>
      <tr>
        <td class="s-label">sma10</td>
        <td class="flex">
          <div [class]="checkStyle(data.sma10)">{{data.sma10}}</div>
          <div [class]="checkStyle(data.sma10Dir)">{{checkDir(data.sma10Dir)}}</div>
        </td>
        <td class="s-label">下軌</td>
        <td [class]="checkStyle(data.LBdir)">{{data.LBT}}</td>
      </tr>
      <tr>
        <td class="s-label">sma20</td>
        <td class="flex">
          <div [class]="checkStyle(data.sma20)">{{data.sma20}}</div>
          <div [class]="checkStyle(data.sma20Dir)">{{checkDir(data.sma20Dir)}}</div>
        </td>
        <td class="s-label">帶寬</td>
        <td [class]="checkStyle(0)">{{data.BBandBW}}%</td>
      </tr>
      <tr>
        <td class="s-label">sma60</td>
        <td class="flex">
          <div [class]="checkStyle(data.sma60)">{{data.sma60}}</div>
          <div [class]="checkStyle(data.sma60Dir)">{{checkDir(data.sma60Dir)}}</div>
        </td>
        <td class="s-label">週漲%</td>
        <td [class]="checkStyle(data.weekPercent)">{{formatPercent(data.weekPercent,1)}}</td>
      </tr>
      <tr>
        <td class="s-label">K棒</td>
        <td [class]="checkStyle(data.KSize)">{{data.KSize}}</td>
        <td class="s-label">月漲%</td>
        <td [class]="checkStyle(data.monthPercent)">{{formatPercent(data.monthPercent,1)}}</td>
      </tr>
      <tr>
        <td class="s-label">價</td>
        <td [class]="checkStyle(data.newPrice)">{{data.newPrice}}</td>
        <td class="s-label">季漲%</td>
        <td [class]="checkStyle(data.seasonPercent)">{{formatPercent(data.seasonPercent,1)}}</td>
      </tr>
      <tr>
        <td class="s-label">周乖離</td>
        <td [class]="checkStyle(data.bias5)">{{formatPercent(data.bias5,1)}}</td>
        <td class="s-label">10乖離</td>
        <td [class]="checkStyle(data.bias10)">{{formatPercent(data.bias10,1)}}</td>
      </tr>
      <tr>
        <td class="s-label">月乖離</td>
        <td [class]="checkStyle(data.bias20)">{{formatPercent(data.bias20,1)}}</td>
        <td class="s-label">季乖離</td>
        <td [class]="checkStyle(data.bias60)">{{formatPercent(data.bias60,1)}}</td>
      </tr>
      <tr>
        <td class="s-label">K</td>
        <td [class]="checkStyle(data.K)">{{formatPercent(data.K,1)}}</td>
        <td class="s-label">D</td>
        <td [class]="checkStyle(data.D)">{{formatPercent(data.D,1)}}</td>
      </tr>
    </table>
  </div>
</div>
<!-- <table class="s-table">
  <tr>
    <td>

    </td>
    <td>

    </td>
  </tr>
</table>
 -->
